module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "alert",
    class: [_vm.seType, _vm.setPosition]
  }, [(!!_vm.close) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', [_vm._v("×")])]) : _vm._e(), _vm._v(" " + _vm._s(_vm.content) + "\n\t"), _vm._t("default")], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-5da3ff0c!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/alert.vue
// module id = 318
// module chunks = 2